import * as types from "./types";

/*---------------------------------------------------------------------------*/

function resetDataSaved() {
  return { type: types.RESET_DATA_SAVED };
}

function saveData(payload) {
  return { type: types.DATA_SAVED, payload };
}

/*---------------------------------------------------------------------------*/

function addedTareaDeVenta(payload) {
  return { type: types.ADDED_TAREA_DE_VENTA, payload };
}
function removedTareaDeVenta(payload) {
  return { type: types.REMOVED_TAREA_DE_VENTA, payload };
}
function changedTareaDeVenta(payload) {
  return { type: types.CHANGED_TAREA_DE_VENTA, payload };
}

/*---------------------------------------------------------------------------*/

function limpiarTareasDeVenta() {
  return { type: types.LIMPIAR_TAREAS_DE_VENTA };
}

/*---------------------------------------------------------------------------*/

export {
  saveData,
  resetDataSaved,
  addedTareaDeVenta,
  removedTareaDeVenta,
  changedTareaDeVenta,
  limpiarTareasDeVenta
};



// WEBPACK FOOTER //
// ./src/ducks/ventasTareas/actions.js